export const DropdownMenu = ({ menuKey, config, onAction, isLocked, isTrialMode = false, dropdownIndex = -1 }: any) => {
  const data = config.topNav[menuKey];
  if (!data) return null;
  const isRightAligned = ['O', 'E', 'P'].includes(menuKey);
  const renderDropdownLabel = (label: string, hotkey: string, disabled: boolean, isTrialBlocked?: boolean) => {
    if (disabled) return (
      <span className="text-[#9ca3af]">
        {label}
        {isTrialBlocked && <span className="ml-1 text-[10px] text-amber-500">🔒</span>}
      </span>
    );
    if (!hotkey || !label) return <span>{label}</span>;
    const idx = label.toLowerCase().indexOf(hotkey.toLowerCase());
    if (idx === -1) return <span>{label}</span>;
    return <span>{label.substring(0, idx)}<span className="font-bold text-[#1e8585] group-hover:text-white">{label[idx]}</span>{label.substring(idx + 1)}</span>;
  };

  const processItems = (items: any[]) => {
    return items.map(item => {
      let disabled = item.disabled;
      let isTrialBlocked = false;
      if (isLocked) {
        if (menuKey === 'C' && ['Alter', 'Backup', 'Delete'].includes(item.label)) {
          disabled = true;
        }
        if (menuKey === 'Y' && ['Backup', 'Setup'].includes(item.label)) {
          disabled = true;
        }
      }
      // Trial mode: strictly block Backup & Restore
      if (isTrialMode && ['Backup', 'Restore'].includes(item.label)) {
        disabled = true;
        isTrialBlocked = true;
      }
      return { ...item, disabled, isTrialBlocked };
    });
  };

  // Build flat enabled list to match dropdownIndex
  const allEnabledItems: string[] = [];
  data.forEach((section: any) => {
    processItems(section.items).filter((i: any) => !i.disabled).forEach((i: any) => allEnabledItems.push(i.label));
  });

  return (
    <div className={`absolute top-full ${isRightAligned ? 'right-0' : 'left-0'} mt-1 w-[180px] bg-[#f8fafc] border border-[#1e8585] shadow-md py-1 z-[100] text-black flex flex-col font-sans cursor-default`}>
      {data.map((section: any, idx: number) => {
        const items = processItems(section.items);
        return (
          <div key={idx} className={idx !== 0 ? "mt-1.5" : ""}>
            {section.group && <div className="px-3 py-[1px] text-[#1e8585] text-[10px] uppercase tracking-wide opacity-90">{section.group}</div>}
            {items.map((item: any, itemIdx: number) => {
              const enabledIdx = allEnabledItems.indexOf(item.label);
              const isHighlighted = !item.disabled && enabledIdx !== -1 && enabledIdx === dropdownIndex;
              return (
                <div
                  key={itemIdx}
                  onClick={item.disabled ? undefined : (e) => onAction(e, item, menuKey)}
                  title={
                    item.isTrialBlocked
                      ? 'Trial mode — upgrade required 🔒'
                      : item.disabled
                      ? 'Not available in current context'
                      : undefined
                  }
                  className={`group flex justify-between items-center px-3 py-[2px] text-[12px] leading-tight ${item.disabled ? 'cursor-default select-none' : 'cursor-pointer hover:bg-[#1e8585] hover:text-white'} ${isHighlighted ? 'bg-[#1e8585] text-white' : ''}`}>
                  <div className="flex-1 text-left">{renderDropdownLabel(item.label, item.hotkey, item.disabled, item.isTrialBlocked)}</div>
                  {item.shortcut && <div className={`ml-3 text-[11px] tracking-wide text-right ${item.disabled ? 'text-[#9ca3af]' : isHighlighted ? 'text-white' : 'text-[#1e8585] group-hover:text-white'}`}>{item.shortcut}</div>}
                  {item.hasArrow && <div className={`ml-2 text-[12px] font-bold ${item.disabled ? 'text-[#9ca3af]' : isHighlighted ? 'text-white' : 'text-[#1e8585] group-hover:text-white'}`}>{'>'}</div>}
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};
